@let markerSelectionUnavailable = isMarkerSelectionUnavailable();
@if (shouldShowMarkerSection()) {
  <section class="form-group markers-group" [class.empty]="!hasMarkerSet">
    @if (!hasMarkerSet) {
      <section>
        <button
          type="button"
          class="link-btn add-btn markers-btn"
          translate="activity-editor-new_markers"
          [disabled]="markerSelectionUnavailable"
          [matTooltip]="'activity-editor-new_markers-unavailable' | translate"
          [matTooltipDisabled]="!markerSelectionUnavailable"
          disabledInteractive
          (click)="openMarkerSelectionModal()">
        </button>
      </section>
    } @else {
      <marker-set-panel
        class="first-auxiliary"
        [markerSet]="selectedMarkerSet"
        [activity]="activity"
        (onEdited)="handleMarkerSetEdited($event)"
        (onRemoved)="handleMarkerSetRemoved()">
      </marker-set-panel>
    }

  </section>
}
